import { useCallback, useMemo } from 'react';

import { FixedDataPicker } from './fixed-data-picker/FixedDataPicker';
import { PriorityEntityLike, usePriority } from './PriorityEntityLikePicker';
import { IPickerProps } from './types';

export { TicketPriority } from './PriorityEntityLikePicker';

export interface IPriorityPickerProps
  extends Omit<
    IPickerProps<PriorityEntityLike, false>,
    'multiple' | 'value' | 'onChange'
  > {
  value: number;
  onChange: (input: number) => void;
}

export function PriorityPicker(props: IPriorityPickerProps) {
  const { value, onChange, ...rest } = props;

  const dataSet = usePriority();

  const wrappedValue = useMemo(() => {
    return dataSet.find((x) => x.id === value);
  }, [dataSet, value]);

  const handleChange = useCallback(
    (newValue: PriorityEntityLike): void => {
      onChange(newValue.id);
    },
    [onChange]
  );

  return (
    <FixedDataPicker
      {...rest}
      multiple={false}
      dataSet={dataSet}
      value={wrappedValue}
      onChange={handleChange}
    />
  );
}
